/**
 * Animation Utilities
 * Framer Motion animation variants and legacy hooks
 */

'use client';

import type { Transition, Variants } from 'framer-motion';

/**
 * Entrance animation variants for components
 * Use with Framer Motion's initial/animate/exit props
 */
export const ENTRANCE_ANIMATIONS = {
  fadeBlur: {
    initial: { opacity: 0, filter: 'blur(8px)' },
    animate: { opacity: 1, filter: 'blur(0px)' },
    exit: { opacity: 0, filter: 'blur(8px)' },
  },
  slideUp: {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  },
  slideFromBottom: {
    initial: { y: '100vh' },
    animate: { y: 0 },
    exit: { y: '100vh' },
  },
  scale: {
    initial: { opacity: 0, scale: 0.9 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 },
  },
} as const;

/**
 * Transition presets for consistent timing
 * Using Material Design standard easing [0.4, 0, 0.2, 1] for smooth deceleration
 */
export const TRANSITIONS = {
  smooth: { duration: 0.6, ease: [0.4, 0, 0.2, 1] } as Transition,
  quick: { duration: 0.3, ease: [0.4, 0, 0.2, 1] } as Transition,
  bouncy: { type: 'spring', stiffness: 300, damping: 20 } as Transition,
  progress: { duration: 1.2, ease: [0.2, 0, 0, 1] } as Transition,
} as const;

/**
 * Container variants for stagger animations
 * Use with parent-child motion components
 * Note: Container itself doesn't animate, only staggers children
 */
export const STAGGER_CONTAINER: Variants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.03 }, // Fast stagger for snappy feel
  },
};

export const STAGGER_ITEM: Variants = {
  hidden: { opacity: 0, y: 20 },
  show: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.3, ease: [0.4, 0, 0.2, 1] }, // Material Design easing
  },
};


